/* eslint-disable no-unused-vars */
import { useState, useContext, useEffect, useMemo, useCallback } from "react";
import AgentLayout from "../../../AdminPortal/Layouts/Layout";
import {
  Row,
  Col,
  Typography,
  Modal,
  Space,
  Select,
  Form,
  Divider,
  Button,
  Tag,
  Input,
  Image,
  Spin,
  Pagination,
  message,
  Carousel,
  Skeleton,
  Affix,
} from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import NoImageAvailable from "../../../../assets/reqest.png";
import useSWR from "swr";
import axios from "axios";
import {
  generateSearchParamsGetter,
  getNewSearchParamStringWithArgs,
  getSearchParams,
} from "../../../AdminPortal/utils/helpers";
import { SearchOutlined } from "@ant-design/icons";
import { colors } from "../../../AdminPortal/utils/colors";
import { CartContext } from "../../../Contexts/CartContext";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { useDebouncedCallback } from "use-debounce";
import { useSearchParams } from "react-router-dom";
import ItemCard from "../../components/Card/ItemCard";
import UserContext from "../../../Contexts/UserContext";
import DropDownComp from "../../components/DropDown";
import { isMobile } from "react-device-detect";
import sortBy from "lodash/sortBy";

import { BASE_URL } from "../../../Constants/EnvironmentVariableProvider";
import {
  REWARDS_FILTER_DATA_API,
  GET_REWARD_BYID,
  ADD_FAVORITE_API,
  AGENT_TOTAL_POINTS_API,
  ALL_CATEGORIES_API,
} from "../../../API/paths";
import { REWARD_INVENTORY_DEFAULT_PAGE_SIZE } from "../../../Constants/ApplicationConstants";
import PointsDisplay from "../../../AdminPortal/components/AgentPoints/AgentPoints";
import FilterHeader from "./FilterHeader";
const { Search } = Input;
const { Text, Title, Link } = Typography;
const { Option } = Select;

const Dashboard = () => {
  const navigate = useNavigate();
  const { addToCart } = useContext(CartContext);
  const { auth } = useContext(UserContext);
  const [singleReward, setSingleReward] = useState(null);
  let [spObj, setSearchParams] = useSearchParams({
    page: "1",
    pageSize: REWARD_INVENTORY_DEFAULT_PAGE_SIZE.toString(),
  });
  spObj.get('page') === null && spObj.set('page', '1');
  spObj.get('pageSize') === null && spObj.set('pageSize', REWARD_INVENTORY_DEFAULT_PAGE_SIZE.toString());

  const searchParams = new URLSearchParams(window.location.search);
  const category_keyids_list = searchParams.get("category_keyids");

  let [id, page, pageSize, search, statusType, category_keyids] =
    getSearchParams(spObj);

  const [modalOpen, setModalopen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  console.log('category_keyids_list', category_keyids_list)
  const [selectedCategory, setSelectedCategory] = useState(
    (category_keyids_list?.length ?? 0) > 0
      ? category_keyids_list.split(",").map((item) => parseInt(item))
      : []
  );
  useEffect(() => {
    (category_keyids_list?.length ?? 0) === 0 && setSelectedCategory([])
  }, [category_keyids_list])

  const [value, setValue] = useState("Value Range");
  const [sliderValue, setSliderValue] = useState(null);
  const [filterVal, setFilterVal] = useState("1");

  const generateRandomSeed = () => {
    const seed = localStorage.getItem('currentSeed')
    if (seed) {
      localStorage.removeItem('currentSeed');
      return seed
    }
    const num = Math.floor(10000000 + Math.random() * 90000000);
    //message.success("generated seed")
    return num.toString();
  };
  const [var_RandomSeed, setVar_RandomSeed] = useState(() => generateRandomSeed());
  
  const [variant_form] = Form.useForm();

  const getNewSearchParamString = generateSearchParamsGetter(spObj);

  const debounceFetcher = useDebouncedCallback((search) => {
    setSearchParams(
      getNewSearchParamStringWithArgs({ page: 1, pageSize, search, category_keyids: category_keyids_list })
    );
  }, 600);
  const rewardApiUrl =
    BASE_URL +
    REWARDS_FILTER_DATA_API +
    getNewSearchParamString() +
    `&orderBy=${filterVal}` +
    `&pointRange=${value === "Value Range" ? "" : value === "Custom Range" ? sliderValue : value
    }` +
    `&statusType=1,4,5&isFavoriteRequired=true&RandomSeed=`+var_RandomSeed;
  const categoryApiUrl = BASE_URL + ALL_CATEGORIES_API;
  
  const {
    data: rewards,
    isValidating: loading,
    mutate: mutateReward,
  } = useSWR({
    url: rewardApiUrl,
  }, null, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    dedupingInterval: 2000,
    shouldRetryOnError: false
  });
    
  const agentId = auth?.result?.ACAG_KeyID;
  const { data: agnetPoints, isValidating: pointsLoading } = useSWR({
    url: `${AGENT_TOTAL_POINTS_API}?KeyId=${agentId}`,
  });

  useEffect(() => {
    localStorage.setItem("totalPoints", JSON.stringify(agnetPoints));
  }, [agnetPoints]);

  const { data: category, isLoading: categoryloading } = useSWR({
    url: categoryApiUrl,
  });
  const onPaginationChange = (page, pageSize) => {
    setSearchParams(
      getNewSearchParamStringWithArgs({
        page,
        pageSize,
        search,
        statusType,
        category_keyids: category_keyids_list,
      })
    );
  };
  const handleFilterChange = (e) => {
    if(e === "1" && filterVal !=="1"){
      setVar_RandomSeed(generateRandomSeed)
    }
    setFilterVal(e);
  };

  const handleReshuffle = () => {
    setVar_RandomSeed(generateRandomSeed());
    onPaginationChange(1,pageSize)
    window.scrollTo(0,0)
    message.config({top: 100})
    message.success("The Shop has been reshuffled!");
  };

  const handleSearch = (value) => {
    setSearchState(value);
    debounceFetcher(value);
  };
  const ModalContoller = async (
    rewardId,
    quantity,
    Agent_Redeemed_Quantity,
    ARLR_Redeemable_Quantity
  ) => {
    if (quantity < 1) {
      message.error("The reward item is no longer available to redeem");
      return;
    }

    if (
      ARLR_Redeemable_Quantity &&
      Agent_Redeemed_Quantity >= ARLR_Redeemable_Quantity
    ) {
      message.error("You have already redeemed the available quantity.");
      return;
    }
    try {
      setModalopen(true);
      setModalLoading(true);
      const response = await axios.get(`${GET_REWARD_BYID}?Id=${rewardId}`);
      const result = response?.data?.result;
      result?.tbl_ARRV_Reward_Variants?.forEach((item, index) => {
        if (index === 0) {
          item["status"] = true;
        } else {
          item["status"] = false;
        }
      });
      variant_form.setFieldsValue({
        variant_id:
          result?.tbl_ARRV_Reward_Variants[0]?.ARRV_Reward_Variant_KeyID,
      });
      setModalLoading(false);
      setSingleReward(result ? result : null);
    } catch (e) {
      setModalLoading(false);
    }
  };
  const addFav = async (reward_id, fav_status) => {
    if (!rewards || !rewards.result) return;
  
    // Optimistically update the UI first
    const updatedResults = rewards.result.map(item => {
      if (item.ARLR_KeyID === reward_id) {
        return {
          ...item,
          IsFavorite: !fav_status
        };
      }
      return item;
    });
    
    // Update the UI immediately without waiting for the server
    mutateReward({ ...rewards, result: updatedResults }, false);
    
    // Show optimistic message immediately
    message.success(
      !fav_status
        ? "Reward has been added to favorites"
        : "Remove from favorites"
    );
  
    // Make the actual API call
    const fav_data = {
      ARFA_Agent_ACAG_KeyID: auth?.result?.ACAG_KeyID,
      ARFA_Reward_ARLR_KeyID: reward_id,
      ARFA_zalt_Altered_Type: !fav_status,
    };
  
    try {
      const response = await axios.post(ADD_FAVORITE_API, fav_data);
      
      if (!response?.data?.success) {
        message.error(response?.data?.message);
        // Revert the UI change
        mutateReward();
      }
    } catch (e) {
      console.log(e);
      message.error("There was an error updating your favorites");
      mutateReward();
    }
  };
  const handleVariantChange = (values) => {
    if (!values) {
      return;
    }
    let dataCopy = { ...singleReward };
    const index = dataCopy?.tbl_ARRV_Reward_Variants?.findIndex(
      (item) => item?.ARRV_Reward_Variant_KeyID === values
    );
    dataCopy?.tbl_ARRV_Reward_Variants?.forEach((item, item_index) => {
      if (item_index === index) {
        item.status = true;
      } else {
        item.status = false;
      }
    });
    setSingleReward(dataCopy);
  };

  const categoryHandleMultiple = (multiple_cat_ids) => {
    if (multiple_cat_ids.length === 0) {
      setSelectedCategory([]);
      setSearchParams(
        getNewSearchParamStringWithArgs({
          page: 1,
          pageSize,
          search,
          statusType,
          category_keyids: "",
        })
      );
      return;
    } else {
      let category_keyids = "";

      multiple_cat_ids?.forEach((item, index) => {
        category_keyids +=
          item + (index !== multiple_cat_ids?.length - 1 ? "%2C" : "");
      });

      setSelectedCategory(multiple_cat_ids);
      setSearchParams(
        getNewSearchParamStringWithArgs({
          page: 1,
          pageSize,
          search,
          statusType,
          category_keyids,
        })
      );
    }
  };
  // useEffect(() => {
  //   if (mutateReward) mutateReward();
  // }, [search, pageSize, page, mutateReward, category_keyids, value, filterVal]);

  const getCategoryOption = (category) => {
    let categoryOption = [];
    if (category !== null && category !== undefined && category.length > 0) {
      sortBy(category, ["Reward_Quantity"])
        .reverse()
        .forEach((item) => {
          categoryOption.push({
            value: item?.ARLC_KeyID,
            label: item?.ARLC_Title,
            quantity: item?.Reward_Quantity,
          });
        });
    }
    return categoryOption;
  };

  const categoryOption = getCategoryOption(category?.result);

  let imageSrc = singleReward?.ARLR_Images_Path ? [...singleReward.ARLR_Images_Path] : [];
  if (singleReward?.ARLR_Image_Path) {
    imageSrc.unshift(singleReward?.ARLR_Image_Path);
  }
  imageSrc = (imageSrc?.length ?? 0) === 0 ? [NoImageAvailable] : imageSrc;

  const handleCancelClick = () => {
    imageSrc = [NoImageAvailable];
    setModalopen(false);
  };

  const [searchState, setSearchState] = useState(search ? search : "");
  useEffect(() => {
    setSearchState(search)
  }, [search])

  return (
      <AgentLayout>
      <FilterHeader 
  handleSearch={handleSearch}
  handleFilterChange={handleFilterChange}
  setValue={setValue}
  setSliderValue={setSliderValue}
  value={value}
  selectedCategory={selectedCategory}
  categoryHandleMultiple={categoryHandleMultiple}
  categoryOption={categoryOption}
  handleReshuffle={handleReshuffle}
  agentPoints={agnetPoints}
  searchState={searchState}
/>
        <div style={{
          paddingLeft: isMobile ? 14 : 60,
          paddingRight: isMobile ? 14 : 60,
          marginTop: 28,
          marginBottom: 20,
        }}>
          <Row
            gutter={{
              xs: 8,
              sm: 16,
              md: 24,
              lg: 32,
            }}
          >
          {loading ? (
            [...Array(12)].map((_, index) => (
              <Col
                key={`skeleton-${index}`}
                className="gutter-row"
                xs={24}
                sm={12}
                md={8}
                lg={6}
                xl={6}
                xxl={4}
              >
                <ItemCard
                  src=""
                  addFav={() => {}}
                  productName="loading..."
                  category_title="      "
                  norm_points={" "}
                  index={index}
                />
              </Col>
            ))
          ) : rewards?.result?.map((item, index) => {
              return (
                <Col
                  key={"agent-dashboard-rewards" + index}
                  className="gutter-row"
                  xs={24}
                  sm={12}
                  md={8}
                  lg={6}
                  xl={6}
                  xxl={4}
                >

                  <ItemCard
                    rewardId={item?.ARLR_KeyID}
                    addFav={addFav}
                    quantity={item?.ARLR_Quantity}
                    category_title={item?.tbl_ARLC_Categories?.ARLC_Title}
                    favorite={item?.IsFavorite}
                    productName={item?.ARLR_Title}
                    src={item?.ARLR_Image_Path}
                    loading={loading}
                    index={index}
                    norm_points={item?.ARLR_Norm_Points}
                    ModalContoller={ModalContoller}
                    Agent_Redeemed_Quantity={item?.Agent_Redeemed_Quantity}
                    ARLR_Redeemable_Quantity={item?.ARLR_Redeemable_Quantity}
                  />
                </Col>
              );
            })}
          </Row>

          {rewards?.result?.length > 0 ? (
            <Pagination
              style={{
                float: "right",
                marginBottom: 20,
                position: "relative",
                marginTop: "16px",
              }}
              showSizeChanger
              showTotal={(total, range) => `Showing ${range[0]} to ${range[1]} of ${total} results`}
              onChange={(page, pageSize) => {window.scrollTo(0, 0); onPaginationChange(page, pageSize)}}
              current={Number(page)}
              pageSizeOptions={[12,24,48,72,]}
              total={rewards?.totalRecords}
              className="pagination-dropdown-custom pagination-component"
              pageSize={Number(pageSize)}
            />
          ) : (
            ""
          )}
        </div>

        <Modal
          open={modalOpen}
          footer={null}
          width="80vw"
          onCancel={handleCancelClick}
        >
          <Spin spinning={modalLoading}>
            <div style={{ backgroundColor: colors.bgGrey }}>
              <Row align="middle">
                <Col
                  span={isMobile ? 24 : 12}
                  style={{ backgroundColor: colors.white }}
                >
                  {modalLoading ? null :
                    <Carousel
                     arrows 
                     prevArrow={<LeftOutlined />}
                     nextArrow={<RightOutlined />}
                     style={{
                      height: isMobile ? 350 : 580,
                      width: "100%",
                      backgroundColor: "rgb(246, 248, 251)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: 'center',
                      position: "relative"
                    }}>
                      {imageSrc.map((item) => (
                        <div key={item}>
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgb(246, 248, 251)" }}>
                            <img style={{ height: 350, width: 280, objectFit: "contain" }} src={item} alt="link" />
                          </div>
                        </div>
                      ))
                      }
                    </Carousel>}
                </Col>
                <Col span={isMobile ? 24 : 12}>
                  <div style={{ padding: "0 24px" }}>
                    <Space
                      direction="vertical"
                      style={{ width: "100%", paddingTop: "60px" }}
                    >
                      <Text
                        style={{
                          color: colors.black,
                          fontSize: 18,
                          fontWeight: 500,
                        }}
                      >
                        {singleReward?.ARLR_Title}
                      </Text>
                      <Text>
                        <pre
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            fontFamily: "inherit",
                            maxHeight: "300px",
                            overflowY: "auto",
                          }}
                        >
                          {singleReward?.ARLR_Description}
                        </pre>
                      </Text>
                      <Divider style={{ marginTop: 5 }} />
                      <Form
                        form={variant_form}
                        layout="vertical"
                        style={{ marginTop: -10 }}
                      >
                        {singleReward?.tbl_ARRV_Reward_Variants?.length < 1 ||
                          !singleReward?.tbl_ARRV_Reward_Variants ? (
                          ""
                        ) : (
                          <Form.Item
                            label="Select Variant"
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            name="variant_id"
                          >
                            <Select
                              style={{ width: "100%" }}
                              onChange={handleVariantChange}
                              disabled={
                                singleReward?.tbl_ARRV_Reward_Variants?.length <
                                1 || !singleReward?.tbl_ARRV_Reward_Variants
                              }
                            >
                              {singleReward?.tbl_ARRV_Reward_Variants?.map(
                                (item) => (
                                  <Option
                                    key={"agent-dashboard-options" + item}
                                    value={item?.ARRV_Reward_Variant_KeyID}
                                  >
                                    {item?.ARRV_Title}
                                  </Option>
                                )
                              )}
                            </Select>
                          </Form.Item>
                        )}
                      </Form>
                      {!(
                        singleReward?.tbl_ARRV_Reward_Variants?.length < 1 ||
                        !singleReward?.tbl_ARRV_Reward_Variants
                      ) && <Divider style={{ marginTop: -10 }} />}
                      <Text
                        style={{
                          float: "right",
                          fontWeight: 600,
                          fontSize: 16,
                        }}
                      >
                        Total Reward Points
                      </Text>
                      <Text
                        style={{
                          float: "right",
                          fontWeight: 600,
                          fontSize: 16,
                          color: colors.black,
                        }}
                      >
                        {singleReward?.ARLR_Norm_Points}
                      </Text>
                      <Button
                        onClick={() => {
                          localStorage.setItem('currentSeed', var_RandomSeed);
                          addToCart(singleReward, setModalopen);
                        }}
                        type="primary"
                        disabled={singleReward?.ARLR_Quantity < 1}
                        style={{ width: "100%", marginTop: 10 }}
                      >
                        Add to cart
                      </Button>
                      <Button
                        type="text"
                        onClick={handleCancelClick}
                        style={{
                          width: "100%",
                          color: colors.black,
                          background: colors.white,
                          marginBottom: 10,
                        }}
                      >
                        Cancel
                      </Button>
                    </Space>
                  </div>
                </Col>
              </Row>
            </div>
          </Spin>
        </Modal>
      </AgentLayout>
  );
};
export default Dashboard;
